import { ManufacturingMaterialDeleteConfirm } from "./ManufacturingMaterialDeleteConfirm";
import type { MfgMaterialUse } from "@/lib/manufacturing/types";

const dangerBtnClass =
  "rounded-lg bg-rose-600 px-3 py-1.5 text-sm font-semibold text-white hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-60";

type Props = {
  use: MfgMaterialUse;
  disabled?: boolean;
  pending: {
    use: MfgMaterialUse;
    busy: boolean;
    error: string | null;
    blockers: Array<{ code: string; message: string }>;
  } | null;
  onRequest: (use: MfgMaterialUse) => void;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ManufacturingMaterialUseDeleteControls({
  use,
  disabled,
  pending,
  onRequest,
  onConfirm,
  onCancel,
}: Props) {
  const open = Boolean(pending && pending.use.id === use.id);

  return (
    <>
      <button
        type="button"
        className={dangerBtnClass}
        disabled={disabled || pending?.busy}
        onClick={() => onRequest(use)}
        title="Delete this Part use when no recipes reference it"
      >
        Delete use
      </button>
      <ManufacturingMaterialDeleteConfirm
        open={open}
        variant="delete"
        title={`Delete “${use.name}”?`}
        confirmLabel={pending?.busy ? "Deleting…" : "Delete forever"}
        busy={pending?.busy}
        onCancel={onCancel}
        onConfirm={onConfirm}
        body={
          <div className="space-y-2 text-sm text-gray-700 dark:text-zinc-300">
            <p>
              Permanently delete <strong>{use.use_code}</strong>. Members cascade away. This cannot
              be undone.
            </p>
            <p className="text-xs text-gray-500 dark:text-zinc-400">
              Blocked when any recipe BOM line still references this use.
            </p>
            {pending?.error ? (
              <p className="text-sm text-rose-700 dark:text-rose-300">{pending.error}</p>
            ) : null}
            {pending && pending.blockers.length > 0 ? (
              <ul className="list-disc space-y-1 pl-5 text-sm text-amber-800 dark:text-amber-200">
                {pending.blockers.map((b) => (
                  <li key={b.code}>{b.message}</li>
                ))}
              </ul>
            ) : null}
          </div>
        }
      />
    </>
  );
}
